// components/LoadingContext.jsx
import React, { createContext, useState, useContext, useCallback } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const startLoading = useCallback(() => {
    setCount(c => c + 1);
  }, []);

  const finishLoading = useCallback(() => {
    setCount(c => Math.max(c - 1, 0));
  }, []);

  return (
    <LoadingContext.Provider value={{
      loading: count > 0,
      startLoading,
      finishLoading,
    }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
